import { render, staticRenderFns } from "./tmDiagPoint.vue?vue&type=template&id=63843722&scoped=true&"
import script from "./tmDiagPoint.vue?vue&type=script&lang=js&"
export * from "./tmDiagPoint.vue?vue&type=script&lang=js&"
import style0 from "./tmDiagPoint.vue?vue&type=style&index=0&id=63843722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63843722",
  null
  
)

export default component.exports